module.exports = __webpack_public_path__ + "img/conection.5dfc3394.png";